import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Row
} from 'reactstrap';

import WidePropertyCard from '../../../components/properties/WidePropertyCard';
import PolyUtil from '../../../util/PolyUtil';
import {AsyncButton} from "../../../components/controls/buttons/AsyncButton";
import {handleRemoveFromInterestList} from "../actions/tenant";

class TenantInterestList extends Component {
    content = () => {
        const {interest_list, _handleRemoveFromInterestList } = this.props;

        return (
            <div>{
                interest_list && interest_list.length !== 0 &&
                (
                    <div>
                        <h3 className="mt-4 mb-0">Saved Properties</h3>
                        <hr/>
                        <Row>
                            {
                                PolyUtil.validArr(interest_list) ? interest_list.map(function (property, i) {
                                    return (
                                        <WidePropertyCard key={i} propertyUrl={!PolyUtil.childrenNull(property.active_listing) ? ("/listings/" + property.active_listing.apply_key + "/") : '/dashboard/'}
                                                      city={PolyUtil.getPropertyCity(property)}
                                                      state={PolyUtil.getPropertyState(property)}
                                                      identifier={property.identifier}
                                                      isListed={property.active_listing.rent !== null}
                                                      noListingButton={(
                                                          <AsyncButton task={() => _handleRemoveFromInterestList(property)} outline style={{color: 'white'}} size="sm" color="danger">
                                                              Remove from Saved
                                                          </AsyncButton>
                                                      )}
                                                      image={property.image}
                                                      display_address={PolyUtil.getPropertyStreetAddress(property)} imageOnly/>
                                    );
                                }) : (<h4>You don't have any saved properties</h4>)
                            }
                        </Row>
                    </div>
                )
            }</div>
        );
    };

    render() {
        return PolyUtil.polyRender(this.props, ['interest_list'], this.content, null);
    }
}

const mapStateToProps = (state) => ({
    interest_list: state.tenant.interest_list
});

const mapDispatchToProps = (dispatch) => ({
    _handleRemoveFromInterestList(propId) {
        return dispatch(handleRemoveFromInterestList(propId));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TenantInterestList);



// WEBPACK FOOTER //
// ./src/containers/tenant/dashboard/TenantInterestList.js